module.exports = __webpack_public_path__ + "static/media/01.b4b22d7b.png";